import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from 'browserHistory'
import { compose } from 'recompose'
import classNames from 'classnames'
import dateFns from 'date-fns'

import PlanSelector from '../components/PlanSelector'
import ConfirmationModal from 'components/Utils/Modal/Confirm'
import { Button, Text } from 'components/base'
import { CouponLabel } from '../components'
import ErrorMessage from '../components/ErrorMessage'

import providesOrganizationPaymentInfos from '../../dataSync/providesOrganizationPaymentInfos'
import providesAvailablePlans from '../dataSync/providesAvailablePlans'
import providesSwitchToPlan from '../dataSync/providesSwitchToPlan'
import providesCancelSubscription from '../dataSync/providesCancelSubscription'

import { selectors as OrganizationsSelectors } from 'data/organizations'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as PaymentSelectors } from 'data/payment'

import RoutesHelper from 'helpers/RoutesHelper'

import { totalForUsersToDollars } from '../utils'

export class Switch extends Component {
  state = {
    selectedPlanIndex: 0,

    showSwitchModal: false,
    switching: false,
    switchSuccess: false,
    switchError: null,

    showCancelModal: false,
    canceling: false,
    cancelSuccess: false,
    cancelError: null,
  }

  componentWillReceiveProps = ({ plan }) => {
    if (plan && this.props.plan && plan.length === this.props.plan.length) {
      return
    }
    for (let index = 0; index < this.props.plans.length; index++) {
      if (this.props.plans[index].id === plan.id) {
        this.setState({ selectedPlanIndex: index })
        break
      }
    }
  }

  renderDowngrade = () => {
    let freePlanIndex = null
    for (let index = 0; index < this.props.plans.length; index++) {
      if (this.props.plans[index].isFree) {
        freePlanIndex = index
        break
      }
    }
    return (
      <div className="flexbox flexbox-align-center margin-vertical-large">
        <div className=" shade-40 margin-right-large">or</div>
        <Button.Secondary
          onClick={() => this.onSelectAndUpgrade(freePlanIndex)}
        >
          Downgrade to free
        </Button.Secondary>
      </div>
    )
  }

  render() {
    if (!this.props.hasAccess) {
      return <div>You don't have access to this section</div>
    }

    if (this.props.paymentInfoFetchState.error) {
      return (
        <ErrorMessage
          retry={this.props.forceQuery}
          action="getting your billing information"
          message={this.props.paymentInfoFetchState.error.message}
        />
      )
    }

    if (
      this.props.paymentInfoFetchState.loading ||
      this.props.paymentInfoFetchState.pristine
    ) {
      return <div>Loading your billing information...</div>
    }

    return (
      <React.Fragment>
        {this.state.switchSuccess && (
          <div className="margin-vertical-large radius-normal background-green shade-100-important padding-horizontal-large padding-vertical-medium">
            <div className="font-weight-bold margin-bottom-smaller">
              You've successfully switched plan{' '}
              <span role="img" aria-label="party-emoji">
                🎉
              </span>
            </div>
          </div>
        )}
        {this.state.switchError && (
          <div className="force-light-mode margin-vertical-large radius-normal background-red shade-100-important padding-horizontal-large padding-vertical-medium">
            <div className="font-weight-bold margin-bottom-smaller">
              There was an error while switching plan:{' '}
              {this.state.switchError.message}
            </div>
          </div>
        )}
        {this.state.cancelError && (
          <div className="force-light-mode margin-vertical-large radius-normal background-red shade-100-important padding-horizontal-large padding-vertical-medium">
            <div className="font-weight-bold margin-bottom-smaller">
              There was an error while canceling plan:{' '}
              {this.state.cancelError.message}
            </div>
          </div>
        )}
        <Text.Subtitle className="margin-vertical-larger">
          Current plan
          {this.props.subscription.canceledAt && ' (Canceled)'}
        </Text.Subtitle>
        <CurrentPlanLine label="Plan name">
          {this.props.plan.name}
        </CurrentPlanLine>
        <CurrentPlanLine label="Usage">
          {this.props.organization.activeUsersCount} members
        </CurrentPlanLine>
        <CurrentPlanLine label="Recurring bill">
          <span className="capitalize">{this.props.plan.interval}</span>
        </CurrentPlanLine>
        <CurrentPlanLine label="Price">
          <div className="flexbox flexbox-space-between flexbox-align-center">
            <div>
              {totalForUsersToDollars(
                this.props.plan.amount,
                this.props.organization.activeUsersCount
              )}{' '}
              per {this.props.plan.interval}
            </div>
            {this.props.coupon && (
              <div className="margin-left-huge">
                <CouponLabel coupon={this.props.coupon} />
              </div>
            )}
          </div>
        </CurrentPlanLine>
        <CurrentPlanLine
          label={
            this.props.subscription.canceledAt
              ? 'Downgraded at'
              : 'Next payment'
          }
          border={false}
        >
          {dateFns.format(
            this.props.subscription.currentPeriodEnd,
            'MMMM Do, YYYY'
          )}{' '}
          (in{' '}
          {dateFns.distanceInWords(
            Date.now(),
            this.props.subscription.currentPeriodEnd
          )}
          )
        </CurrentPlanLine>
        <ConfirmationModal
          cancelLabel="Cancel"
          confirmLabel={this.state.switching ? 'Switching plan...' : 'Confirm'}
          ConfirmButtonComponent={Button.Primary}
          onCancel={this.onCancelModal}
          onConfirm={this.onConfirmSwitchModal}
          show={this.state.showSwitchModal}
        >
          <div className="text-align-left">
            <div className="font-weight-bold font-size-large shade-05 margin-bottom-smaller">
              Are you sure you want to change your subscription?
            </div>
            <div className="font-size-small shade-10">
              This will be effective immediately.
            </div>
          </div>
        </ConfirmationModal>
        <ConfirmationModal
          cancelLabel="Abort"
          confirmLabel={this.state.canceling ? 'Canceling plan...' : 'Confirm'}
          ConfirmButtonComponent={Button.Danger}
          onCancel={this.onCancelModal}
          onConfirm={this.onConfirmCancelModal}
          show={this.state.showCancelModal}
        >
          <div className="text-align-left">
            <div className="font-weight-bold font-size-large shade-05 margin-bottom-smaller">
              Are you sure you want to cancel your subscription?
            </div>
            <div className="font-size-small shade-10">
              This will be effective at the end of the current billing period.
            </div>
          </div>
        </ConfirmationModal>
        {!this.props.subscription.canceledAt && (
          <React.Fragment>
            <Text.Subtitle className="line-height-largest margin-top-medium margin-bottom-larger">
              Change your subscription
            </Text.Subtitle>
            <PlanSelector
              plan={this.props.plan}
              plans={this.props.plans}
              activeUsersCount={this.props.organization.activeUsersCount}
              selectedPlanIndex={this.state.selectedPlanIndex}
              onSelectAndUpgrade={this.onSelectAndUpgrade}
              onSelectPlan={selectedPlanIndex =>
                this.setState({ selectedPlanIndex })
              }
            />
          </React.Fragment>
        )}
        {this.renderDowngrade()}
      </React.Fragment>
    )
  }

  onSelectAndUpgrade = selectedPlanIndex => {
    const targetPlan = this.props.plans[selectedPlanIndex]

    if (targetPlan.isFree) {
      this.setState({ selectedPlanIndex, showCancelModal: true })
    } else {
      this.setState({ selectedPlanIndex, showSwitchModal: true })
    }
  }

  onCancelModal = () => {
    this.setState({ showSwitchModal: false, showCancelModal: false })
  }

  onConfirmSwitchModal = () => {
    if (this.state.switching) {
      return
    }

    this.setState({ switching: true })
    const targetPlan = this.props.plans[this.state.selectedPlanIndex]

    this.props.switchToPlan({ input: { planId: targetPlan.id } }).then(
      () => {
        this.setState(state => ({
          showSwitchModal: false,
          switching: false,
          selectedPlanIndex: 0,
          switchSuccess: true,
        }))
        history.push(
          RoutesHelper.settingsOrganization({
            tabId: 'billing',
            options: 'overview',
            messageId: 'switchSuccess',
          })
        )
      },
      ({ error }) => {
        this.setState({ showSwitchModal: false, switchError: error })
      }
    )
  }

  onConfirmCancelModal = () => {
    if (this.state.canceling) {
      return
    }

    this.setState({ canceling: true })
    this.props.cancelPlanSubscription().then(
      () => {
        this.setState(state => ({
          showCancelModal: false,
          canceling: false,
          selectedPlanIndex: null,
          cancelSuccess: true,
        }))
        history.push(
          RoutesHelper.settingsOrganization({
            tabId: 'billing',
            options: 'overview',
            messageId: 'cancelSuccess',
          })
        )
      },
      ({ error }) => {
        this.setState({ showCancelModal: false, cancelError: error })
      }
    )
  }
}

export default compose(
  providesOrganizationPaymentInfos,
  providesAvailablePlans,
  providesSwitchToPlan,
  providesCancelSubscription,
  connect(state => {
    const organization = OrganizationsSelectors.getOrganization(state)
    const plan = PaymentSelectors.getOrganizationPlan(state)
    const paymentInfos = PaymentSelectors.getOrganizationPaymentInfos(state)
    const coupon = PaymentSelectors.getOrganizationCoupon(state)
    const subscription = PaymentSelectors.getOrganizationSubscription(state)
    const plans = PaymentSelectors.getSortedlistOfAvailablePlans(state, {
      withFree: true,
    })
    return {
      hasAccess: UsersSelectors.hasAccessToPaidBillingViews(state),
      plan,
      paymentInfos,
      coupon,
      subscription,
      plans,
      organization,
    }
  })
)(Switch)

function CurrentPlanLine({ label, children, border = true }) {
  return (
    <div
      className={classNames(
        'flexbox padding-vertical-medium',
        border && 'border-bottom-small border-shade-40'
      )}
    >
      <div style={{ width: 200 }} className="shade-10">
        {label}
      </div>
      <div className="shade-05">{children}</div>
    </div>
  )
}
